import { jsx } from 'react/jsx-runtime';
import { Content, SubContent } from '@radix-ui/react-context-menu';
import { keyframes, styled, css } from 'styled-components';
import { componentBaseConfig } from '../../styled-components/componentBaseConfig.js';

const fadeIn = keyframes([
  `from{opacity:0;}to{opacity:1;}`
]);
const fadeOut = keyframes([
  `from{opacity:1;}to{opacity:0;}`
]);
const ContextMenuItemsContainer = styled.div.withConfig({
  displayName: "ContextMenuContent__ContextMenuItemsContainer",
  componentId: "sc-f7ff45c9-0"
})([
  `padding:3px;border-radius:12px;background:rgba(0,0,0,0.8);border:1px solid rgba(255,255,255,0.1);min-width:190px;will-change:opacity;opacity:0;`
]);
const cssContent = css([
  `transition:0.1s opacity;opacity:0;&[data-state='open']{animation:`,
  ` 0.1s ease-out forwards;`,
  `{animation:`,
  ` 0.1s ease-out forwards;}}&[data-state='closed']{animation:`,
  ` 0.1s ease-out forwards;`,
  `{animation:`,
  ` 0.1s ease-out forwards;}}div:has(> &){z-index:126 !important;}`
], fadeIn, ContextMenuItemsContainer, fadeIn, fadeOut, ContextMenuItemsContainer, fadeOut);
const ContextMenuContent = styled(Content).withConfig(componentBaseConfig).attrs((props) => {
  return {
    ...props,
    children: /* @__PURE__ */ jsx(ContextMenuItemsContainer, {
      children: props.children
    })
  };
}).withConfig({
  displayName: "ContextMenuContent",
  componentId: "sc-f7ff45c9-1"
})([
  ``,
  ``
], cssContent);
const ContextMenuSubContentBase = styled(SubContent).withConfig(componentBaseConfig).attrs((props) => {
  return {
    sideOffset: 8,
    alignOffset: 8,
    ...props,
    children: /* @__PURE__ */ jsx(ContextMenuItemsContainer, {
      children: props.children
    })
  };
}).withConfig({
  displayName: "ContextMenuContent__ContextMenuSubContentBase",
  componentId: "sc-f7ff45c9-2"
})([
  ``,
  `;div:has(> &){left:5px !important;top:-4px !important;z-index:127 !important;}`
], cssContent);

export { ContextMenuContent, ContextMenuSubContentBase };
//# sourceMappingURL=ContextMenuContent.js.map
